export default __webpack_public_path__ + "static/media/tutorial.f67db54e.png";